module.exports = __webpack_public_path__ + "imgs/Levo.9a4c8f35533e3165f78992056f0f8fdd.png";